import { render, staticRenderFns } from "./ClubCardGettingPreloader.vue?vue&type=template&id=61da616a&"
import script from "./ClubCardGettingPreloader.vue?vue&type=script&lang=js&"
export * from "./ClubCardGettingPreloader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61da616a')) {
      api.createRecord('61da616a', component.options)
    } else {
      api.reload('61da616a', component.options)
    }
    module.hot.accept("./ClubCardGettingPreloader.vue?vue&type=template&id=61da616a&", function () {
      api.rerender('61da616a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/Club/components/core/ClubCardGetting/components/common/ClubCardGettingPreloader.vue"
export default component.exports